module.exports = __webpack_public_path__ + "media/images/tokubai-b37bd36641fbf7e6ea6f06752e60c883.png";